import React from 'react';
import { FormattedMessage } from 'react-intl';

const ExternalCalButtonStrings = {
  recommendedBadge: (
    <FormattedMessage
      id="hosting.calendar_main.external_calendar_modal_recommended"
      defaultMessage="Recommended"
    />
  )
};

export default ExternalCalButtonStrings;
